<script setup>
import AppLayout from "../../Layouts/AppLayout.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import SecondaryButton from "../../Components/SecondaryButton.vue";
import MediaUpload from "../../Components/Common/Media/MediaUpload.vue";
import {useHelpers} from "../../helpers";

defineProps({
  media: Object
})
const helpers = useHelpers();
const currentUser = usePage().props.value.auth.user;
</script>

<template>
  <AppLayout title="Operations">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        Operations
      </h2>
    </template>

    <div class="max-w-full py-10 sm:px-6 lg:px-8">
      <!--<p class="mb-5">
        <a href="/content/operations/phoneprocedures.php" class="mr-5">
          <SecondaryButton>Phone Procedures</SecondaryButton>
        </a>
        <a href="/content/operations/closingprocedures.php" class="mr-5">
          <SecondaryButton>Closing Procedures</SecondaryButton>
        </a>
        <a href="/content/operations/manual.php">
          <SecondaryButton>Employee Manual</SecondaryButton>
        </a>
      </p>-->

      <MediaUpload
        :media-input="media"
        :can-see-upload-form="helpers.userHasPermission(currentUser, 'admin')"
        :can-modify-media-details="helpers.userHasPermission(currentUser, 'admin')"
        :hide-save="false"
        media-location="operations"
      ></MediaUpload>
    </div>
  </AppLayout>
</template>
